import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, profile, urlJs, walletcode } from 'config/config'; // Importing configuration variables

/**
 * Class representing the bet history view.
 * @extends JetView
 */
export default class betHistoryView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        var lng = 'es-ES'; // Default language set to Spanish
        // Check the application's locale service for the current language
        if (this.app.getService('locale').getLang() == 'en') {
            lng = 'en'; // Set language to English if applicable
        } else {
            lng = 'es-ES'; // Default to Spanish
        }
        var skinIdITN; // Variable to hold the skin ID
        // Determine the skin ID based on the profile
        if (profile.skinIdITN == undefined || profile.skinIdITN == undefined || profile.skinIdITN == null) {
            skinIdITN = 'doradobet'; // Default skin ID
        } else {
            skinIdITN = profile.skinIdITN; // Use the profile's skin ID
        }
        var typeSkinITN = '0'; // Variable to hold the type of skin
        var skinJsITN = ''; // Variable to hold the JavaScript skin file
        typeSkinITN = profile.typeSkinITN; // Get the type of skin from the profile
        skinJsITN = profile.skinJsITN; // Get the JavaScript skin file from the profile
        // Load the skin JavaScript based on the type of skin
        if (typeSkinITN == '1') {
            webix.require([skinJsITN], function () {
                var options = {
                    token: profile.TokenSportsbook, // Token for sportsbook
                    skinid: skinIdITN, // Skin ID
                    walletcode: profile.walletcodeSportbookITN, // Wallet code
                    full: true, // Full view option
                    page: 'mybets', // Page identifier
                    lang: lng, // Language
                    fixed: false, // Fixed option
                };
                options.isHashMode = false; // Hash mode setting
                options.isHashClassesMode = true; // Hash classes mode setting
                var BIA = new AltenarSportsbook(
                    '#BIA_client_container', // Container for the sportsbook
                    options, // Options for the sportsbook
                );
            });
        } else if (typeSkinITN == '4') {
            webix.require([skinJsITN], function () {
                // Initialize the Altenar SDK for type 4 skin
                window.altenarWSDK.init({
                    integration: skinIdITN, // Integration identifier
                    culture: lng, // Culture/language
                    token: profile.TokenSportsbook, // Token for sportsbook
                    oddsFormat:
                        profile.oddsFormat != undefined
                            ? profile.oddsFormat // Odds format from profile
                            : 0, // Default odds format
                });
                window.altenarWSDK.set({ token: profile.TokenSportsbook }); // Set the token
                // Add the bet history widget
                window.WBS = window.altenarWSDK.addWidget({
                    widget: 'WBetHistory', // Widget type
                    props: {
                        isPrintingEnabled: true, // Enable printing
                    },
                    container: document.getElementById('BIA_client_container'), // Container for the widget
                });
            });
        } else {
            webix.require([skinJsITN], function () {
                var options = {
                    token: profile.TokenSportsbook, // Token for sportsbook
                    skinid: skinIdITN, // Skin ID
                    walletcode: profile.walletcodeSportbookITN, // Wallet code
                    full: true, // Full view option
                    page: 'mybets', // Page identifier
                    lang: lng, // Language
                    fixed: false, // Fixed option
                };
                var BIA = new AltenarSportsbook(
                    '#BIA_client_container', // Container for the sportsbook
                    options, // Options for the sportsbook
                );
            });
        }
        // Return the template based on the skin type
        if (typeSkinITN == '4') {
            return {
                view: 'template', // Template view
                template:
                    "<div id='BIA_client_container' style='overflow: scroll; height: 100%; width: 100%; background-color: black; padding: 10px;'></div>", // Template HTML
            };
        }
        return {
            view: 'template', // Template view
            template:
                "<div  style='overflow: scroll; height: 100%; width: 100%;'> <div id='BIA_client_container'></div></div>", // Template HTML
        };
    }
}

// FILE DOCUMENTED
